import { put, call } from 'redux-saga/effects';
import { sendRequest } from '../../helpers/saga';
import { logger } from '../../helpers/logger';
import notifications from '../../redux/notifications/actions';

const getLoadData = (actions, api) => {
  function* loadData({ payload }) {
    try {
      const { page = 1, pageSize = 100, column, order, filter = '', id } = payload;

      const result = yield call(
        sendRequest,
        api.load,
        { search: { page, pageSize, column, order, filter }, id },
        notifications.REQUEST_ERROR,
      );

      if (result) {
        const { data, totalCount, filteredCount, sortable_columns } = result.data;
        yield put(
          actions.loadDataSuccess({
            comments: data,
            total: totalCount,
            filteredTotal: filteredCount,
            sortableColumns: sortable_columns,
          }),
        );
      }
    } catch (error) {
      logger.error(error);
    }
  }

  return loadData;
};

const getSendComment = (actions, api) => {
  function* sendComment(data) {
    try {
      const { comment, id } = data.payload;
      const result = yield call(
        sendRequest,
        api.createItem,
        { data: { comment: { body: comment } }, id },
        notifications.REQUEST_ERROR,
      );

      if (result?.data) {
        yield put(actions.sendCommentSuccess());

        return yield put(actions.loadData({ id }));
      }
      yield put(actions.sendCommentFailed());
    } catch (error) {
      logger.error(error);
      yield put(actions.sendCommentFailed());
    }
  }

  return sendComment;
};

export { getSendComment, getLoadData };
